module.exports = __webpack_public_path__ + "img/user_default.0a23efb1.png";